import React from 'react'
import { string, arrayOf, shape, object } from 'prop-types'

// Components
import Article from './Article.jsx'

// Constants
const MAX_ARTICLES = 8

const Editorial = props => {
  const { relatedPages, agentData } = props
  if (!relatedPages) return null
  const filteredRelatedPages = _filterRelatedPages(relatedPages, agentData)
  const articles = filteredRelatedPages.slice(-MAX_ARTICLES)
  return (
    <div className='container-fluid'>
      <div className='row'>
        { articles.map((article, index) => <Article key={article.title} article={article} />) }
      </div>
    </div>
  )
}

// filter out pages based on the agent type that is visiting the page and the excludeTypeRID variable set in SEO-System
const _filterRelatedPages = (relatedPages, agentData) => {
  return relatedPages.filter(page => {
    if (page.pageVariables && page.pageVariables.excludeTypeRIDArray && agentData &&
      page.pageVariables.excludeTypeRIDArray.includes(agentData.typeRID)) {
      return false
    }
    return page;
  })
}

Editorial.propTypes = {
  relatedPages: arrayOf(shape({
    title: string.isRequired,
    description: string.isRequired,
    link: string.isRequired,
    image: string.isRequired
  })).isRequired,
  agentData: object
}
Editorial.defaultProps = {
  agentData: { }
}

export default Editorial



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/homepage/Editorial.jsx